module.exports = __webpack_public_path__ + "img/adminsurf.5b4a2c9b.svg";